import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const IsInvoiceFile = ({ isInvoiceFile, setIsInvoiceFile }) => {
  return (
    <FormControl fullWidth size="small">
      <InputLabel sx={{ fontSize: "14px" }} id="supplier-select-label">
        Fatura Durumu
      </InputLabel>
      <Select
        label="Fatura Durumu"
        value={isInvoiceFile}
        onChange={(e) => setIsInvoiceFile(e.target.value)}
      >
        <MenuItem value="">
          <em>Temizle</em>
        </MenuItem>
        <MenuItem value="0">
          <em>Yok</em>
        </MenuItem>
        <MenuItem value="1">
          <em>Var</em>
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default IsInvoiceFile;
